import {ComparativeDirection} from "@dropDesk/domain/entities/reports/report_ticket_comparative/comparative_metric.entity";

export type FeaturedAttendantStatus = 'rising' | 'stable' | 'falling' | 'insufficient_data';
export type FeaturedAttendantHighlight =
    | 'best_rating'
    | 'highest_volume'
    | 'best_response_time'
    | 'highest_evolution'
    | 'best_overall';

export class FeaturedAttendant {
    id!: string;
    name!: string;
    urlImageProfile?: string;
    rating!: number;
    ticketCount!: number;
    previousRating!: number;
    previousTicketCount!: number;
    avgTimeFirstResponse?: number | null;
    avgTimeResolution?: number | null;
    status!: FeaturedAttendantStatus;
    highlight?: FeaturedAttendantHighlight;
    evolutionScore?: number;
    direction?: ComparativeDirection;
    insufficientDataMessage?: string;

    static fromJson(json: Record<string, any>): FeaturedAttendant {
        return new FeaturedAttendant({
            id: json['id'] as string,
            name: json['name'] as string,
            urlImageProfile: json['urlImageProfile'] as string | undefined,
            rating: json['rating'] as number,
            ticketCount: json['ticketCount'] as number,
            previousRating: json['previousRating'] as number,
            previousTicketCount: json['previousTicketCount'] as number,
            avgTimeFirstResponse: json['avgTimeFirstResponse'] as number | null | undefined,
            avgTimeResolution: json['avgTimeResolution'] as number | null | undefined,
            status: json['status'] as FeaturedAttendantStatus,
            highlight: json['highlight'] as FeaturedAttendantHighlight | undefined,
            evolutionScore: json['evolutionScore'] as number | undefined,
            direction: json['direction'] as ComparativeDirection | undefined,
            insufficientDataMessage: json['insufficientDataMessage'] as string | undefined,
        });
    }

    constructor(props: {
        id: string;
        name: string;
        urlImageProfile?: string;
        rating: number;
        ticketCount: number;
        previousRating: number;
        previousTicketCount: number;
        avgTimeFirstResponse?: number | null;
        avgTimeResolution?: number | null;
        status: FeaturedAttendantStatus;
        highlight?: FeaturedAttendantHighlight;
        evolutionScore?: number;
        direction?: ComparativeDirection;
        insufficientDataMessage?: string;
    }) {
        Object.assign(this, props);
    }
}
